module.exports = __webpack_public_path__ + "static/media/time-discount.792701b2.svg";